<div class="container d-flex justify-content-center align-items-center" style="height: 100%; width: 100%;">
    <div class="card d-flex flex-column p-4 shadow-lg" style="width: 100%; height: 100%; max-width: 500px;">
      <!-- Centered Content -->
      <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
        <!-- Animated Circle -->
        <div class="animated-circle bg-primary rounded-circle d-flex justify-content-center align-items-center"
             style="width: 80px; height: 80px;margin-bottom: 10%;">
             <mat-icon style="color: #fff;">check</mat-icon>
          <!-- <i class="bi bi-check-lg text-white" style="font-size: 2rem;"></i> -->
        </div>
   
        <!-- Success Message -->
        <div class="mt-3 text-center">
          <h4 class="fw-bold">Form has been submitted successfully for Accident ID : {{accidentId}}</h4>
          <p class="small-text">Contact us at <a href="mailto:xyz@stellantis.com">xyz&commat;stellantis.com</a> for more details</p>
        </div>
      </div>
   
      <!-- Buttons at Bottom -->
      <div class="d-flex justify-content-between mt-4">
        <button class="btn btn-primary" (click)="reportAnotherAccident()">Report Another Accident</button>
        <button class="btn btn-secondary" (click)="logout()">Logout</button>
      </div>
    </div>
  </div>